import {makeAutoObservable, runInAction} from "mobx"
import {makePersistable} from "mobx-persist-store"
import poiService from "@ui/services/features/PoiService"
import store from "../"

export interface ILayer {
  readonly list: string[] | null

  init(): void
  toggle(layer: string): void
  has(layer: string): boolean
  show(...layers: string[]): void
}

export class Layer implements ILayer {
  list: string[] | null = null

  constructor() {
    makeAutoObservable(this)

    makePersistable(this, {
			name: "layer",
			properties: ["list"],
			storage: window.localStorage
		})
  }

  init() {
    store.poi.loadCategories().then(() => {
      if (!this.list) {
        runInAction(() => this.list = [...store.poi.categories.map(cat => cat.code)])
      }
    })
  }

  toggle(layer: string): void {
    this.list?.includes(layer)
      ? this.list = this.list.filter(item => item !== layer)
      : this.list = [...(this.list || []), layer]
    poiService.refreshLayer()
  }

  has(layer: string) {
    return (this.list || []).includes(layer)
  }

  show(...layers: string[]) {
    this.list = [...(this.list || []), ...layers.filter(layer => !(this.list || []).includes(layer))]
    poiService.refreshLayer()
  }
}
